import moment from 'moment'
import {utils} from '../components'

export default {
  install(Vue) {
    Vue.filter('date', (value, format) => {
      if (!value) return value;
      format = format || 'YYYY-MM-DD';
      return moment(value).format(format)
    });
    Vue.filter("datetime", (value, format) => {
      if (!value) return value;
      format = format || "YYYY-MM-DD HH:mm:ss";
      return moment(value).format(format);
    });
    Vue.filter('rate', (value) => {
      if (!value) return value;
      return (Number(value) * 100).toFixed(2) + '%'
    });
    Vue.filter('status', (value) => {
      switch (value / 1) {
        case -1:
          return '停用';
        case 0:
          return '草稿';
        case 1:
          return '启用';
        default:
          return value;
      }
    });
    Vue.filter('roleType', (value) => {
      if (!value) return value;
      let types = ['', '管理员', '普通角色'];
      return types[value / 1]
    });
    Vue.filter('featureType', (value) => {
      if (!utils.isNumber(value)) return value;
      let types = ['子系统', '菜单', '按钮'];
      return types[value / 1]
    });
    Vue.filter('modeType', (value) => {
      if (!utils.isNumber(value)) return value;
      let types = ['', '自研 ', '外拓', '其他'];
      return types[value / 1]
    });
    Vue.filter('sexType', (value) => {
      if (!value) return value
      let sexArr = {
        '1': '男', '2': '女'
      }
      return sexArr[value] ? sexArr[value] : value
    });
    Vue.filter('hidePhone', (value) => {
      if (!/^1[0-9]{10}$/.test(value)) return value
      return value.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2")
    });
    Vue.filter('empty', value => {
      if (utils.isEmpty(value)) return '-'
      return value
    });
  }
}
